import React from 'react';
import { createRoot } from 'react-dom/client';
import { Redesign } from './Redesign';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../api/reactQueryClient';

const rootElement = document.getElementById('redesign-root');

if (rootElement) {
    const app = createRoot(rootElement);
    const pageId = rootElement.dataset.currentPageId;

    if (!pageId) throw new Error('No page id found');
    app.render(
        <QueryClientProvider client={queryClient}>
            <Redesign pageId={pageId} />
        </QueryClientProvider>
    );
}